import React, { useState } from "react";
import { Modal, Form, Input, Button, Space, Spin, Checkbox } from "antd";
import {
  changeUserPasswordDatabase,
} from "../database/index";
import { openErrorNotification } from "./Notifications/errorNotification";

function ModalChangePassword({ open, setOpen, email, id, setId }) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [updateUserDoc, setUpdateUserDoc] = useState(false); // Bifa pentru a actualiza și Firestore

  // Funcție pentru a găsi UID-ul utilizatorului pe baza adresei de email

  const handleCancel = () => {
    form.resetFields();
    setOpen(false);
    setId("");
  };

  const onFinish = async (values) => {
    setLoading(true);
    try {
      // 1️⃣ Apelăm funcția pentru schimbarea parolei cu emailul direct
      if (values?.newPassword?.length >= 5) {
        const targetIdentifier = id || email; // Folosește id dacă există, altfel emailul
        await changeUserPasswordDatabase(targetIdentifier, values.newPassword, updateUserDoc);
      }

      setOpen(false);
      setId("");
    } catch (error) {
      openErrorNotification(error.message || "Eroare la schimbarea parolei.");
    }
    setLoading(false);
  };

  return (
    <Modal
      title="Schimbare Parolă"
      open={open}
      onCancel={handleCancel}
      footer={null}
    >
      <Spin spinning={loading} tip="Se schimbă parola...">
        <h5 style={{ textAlign: "center" }}>{email}</h5>
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          style={{ maxWidth: 400, margin: "0 auto" }}
        >
          <Form.Item
            label="Noua Parolă (min 6 caractere)"
            name="newPassword"
            rules={[]}
          >
            <Input.Password placeholder="Introduceți noua parolă" />
          </Form.Item>

          <Form.Item>
            <Checkbox
              checked={updateUserDoc}
              onChange={(e) => setUpdateUserDoc(e.target.checked)}
            >
              Solicită schimbarea parolei
            </Checkbox>
          </Form.Item>

          <Form.Item wrapperCol={{ span: 24 }}>
            <Space>
              <Button
                onClick={handleCancel}
                style={{ backgroundColor: "red", color: "white" }}
              >
                Anulează
              </Button>

              <Button
                htmlType="submit"
                style={{ backgroundColor: "#003d82", color: "white" }}
              >
                Schimbă Parola
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Spin>
    </Modal>
  );
}

export default ModalChangePassword;
